import { useMemo } from 'react';

import type { PearlChainUpdateType, RouteStopType } from '@/types';

import { useProcessedStops } from '@/hooks/use-processed-stops';
import isSameDayAsToday from '@/utils/helpers/is-same-day-as-today';

const useGetPearlChain = (
  stopsData: RouteStopType[],
  pearlChainData: PearlChainUpdateType | null | undefined,
  journeyDate?: string,
  journeyId?: string
) => {
  const { passedStops, remainingStops } = useProcessedStops(
    stopsData,
    pearlChainData,
    journeyDate,
    journeyId
  );

  const selectedDate = journeyDate ?? '';
  const isToday = isSameDayAsToday(new Date(selectedDate));

  const hasJourneyEnded = remainingStops.length === 0;

  const isTrainMoving = useMemo(() => {
    const nextStop = remainingStops[0];

    return nextStop?.state !== 'Arrived' && isToday && !hasJourneyEnded;
  }, [remainingStops, passedStops, isToday, hasJourneyEnded]);

  return { passedStops, remainingStops, isTrainMoving, hasJourneyEnded };
};

export default useGetPearlChain;
